window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

var infoBanner = () => {
  const div = document.createElement("div");
  div.innerHTML = `<div class="bundle-card" style="display: flex; flex-direction: column; padding: 20px;margin-bottom: 30px;background-color: #ffc800;color: #000;font-size: 15px;border-radius: 3px;">
      <div class="">
          <p style="">
              For first time purchasers, your first order is already in our queue. The below information is for your <b>next upcoming order</b>. Please reach out to <a href="mailto:info@cheese-grotto.shop">info@cheese-grotto.shop</a> to change your shipping address or clarify ship date for your first order. The shipping schedule can also be found on the product page.
          </p>
          <p style="margin-top: 10px;">
              Future orders are generated on Sunday at 5pmEST. We will ship your order on Tuesday.
          </p>
      </div>
  </div>`;
  return div;
};

function mountInfoBanner() {
  var $leftColumn = document.querySelector(".bundle-subs-detail-layout-column--left");
  if ($leftColumn) {
    $leftColumn.prepend(infoBanner());
  }
}

window.addEventListener("awtomic-cp-loaded", ({ detail } = {}) => {
  setTimeout(mountInfoBanner, 200);
  mountInfoBanner();
});
